import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AssignationDropdownComponent } from '../../assignation-dropdown/assignation-dropdown.component';
import { Activity } from '@app/shared/models/activity.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-activity-form',
    templateUrl: './activity-form.component.html',
    styleUrls: ['./activity-form.component.scss']
})
export class ActivityFormComponent implements OnInit {
    @ViewChild(AssignationDropdownComponent, {static: true}) dropdown: AssignationDropdownComponent;

    @Input() dropdownItems = [];
    @Input() showErrors = false;

    activity: Activity;

    name: string;
    description: string;
    rootPath: string;
    assigned: any;
    priority: number;

    formGroup: UntypedFormGroup;

    constructor(private translate: TranslateService) {
        this.formGroup = new UntypedFormGroup({
            name: new UntypedFormControl(this.name, [Validators.required]),
            description: new UntypedFormControl(this.description, [Validators.required]),
            rootPath: new UntypedFormControl(this.rootPath, [Validators.required]),
            priority: new UntypedFormControl(this.priority, [Validators.required, Validators.pattern(`^[1-9][0-9]*$`)])
        })
    }

    ngOnInit() {
    }

    init(activity: Activity = null) {
        this.activity = activity;
        this.loadFormValue();
        if (activity && activity.assignedRole) {
            this.dropdown.selectedItem = {
                id: activity.assignedRole.id,
                icon: "fa fa-user",
                title: activity.assignedRole.name,
                subtitle: this.translate.instant(
                    `admin.toolMaintenancePlans.activities.modal.${activity.assignedRole.isOob ? 'implicitRole' : 'personalizedRole'}`
                ),
                showAssign: true
            }
        }
    }

    private loadFormValue() {
        if (!this.activity) {
            return;
        }
        const {name, description, rootPath, assignedRole, priority} = this.activity;

        this.formGroup.setValue({name, description, rootPath, priority});
    }

    get valid() {
        return this.formGroup.valid && !!this.dropdown.selectedItem;
    }

    getFormValue() {
        return {
            ...this.formGroup.value,
            assigned: this.dropdown.selectedItem
        };
    }

    reset() {
        this.formGroup.reset();
        this.dropdown.reset();
    }

}
